import React from 'react';
import Icon from './Icon';

const MinusIcon = (props) => (
    <Icon {...props}>
        <path d="M6 12L18 12" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default MinusIcon;